import React from 'react'

export const SearchIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style}
    className={`icon--search ${props.className || ''}`}
    viewBox='-289 381 32 32'
  >
    <path
      d='M-275.1,406.4c-6.4,0-11.6-5.2-11.6-11.6s5.2-11.6,11.6-11.6c6.4,0,11.6,5.2,11.6,11.6S-268.7,406.4-275.1,406.4zM-275.1,385.9c-4.9,0-9,4.1-9,9s4,9,9,9c4.9,0,9-4,9-9S-270.2,385.9-275.1,385.9z'
    />
    <path
      d='M-260.6,410.7c-0.3,0-0.7-0.1-0.9-0.4l-7.3-7.3c-0.5-0.5-0.5-1.3,0-1.8c0.5-0.5,1.3-0.5,1.8,0l7.3,7.3c0.5,0.5,0.5,1.3,0,1.8C-259.9,410.6-260.2,410.7-260.6,410.7z'
    />
  </svg>
)
